<template>
 <div class="eleDetailBox">
   <div class="eleDetailTop">
     <div class="detailLeft">
       <img src="../../assets/images/h5/eleliu.webp" alt="">
       <span>{{ eleDetailTitle }}</span>
     </div>
     <div class="detailRight">
       <slot name="detailMore"></slot>
     </div>
   </div>
   <div class="eleDetailContent">
     <slot name="detailContent"></slot>
   </div>
 </div>
</template>

<script>
export default {
  props:{
    eleDetailTitle:{
      type:String,
      default:''
    }
  }
}
</script>

<style scoped lang="less">
.eleDetailBox{
  width: 100%;
  height: 100%;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.eleDetailTop{
  width: 100%;
  height: 52px;
  min-width: 0;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f0f4f8;
  border-bottom: 1px solid #e8ecf1;
}
.detailLeft{
  display: flex;
  align-items: center;
  gap: 6px;
  color: #252B3C;
  font-size: 14px;
  font-weight: 600;
}
.detailLeft img { width: 18px; height: 18px; }

.eleDetailContent{
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
}
</style>
